import React, { useState } from "react";
import WsrvImage from "../utils/WsrvImage";

export default function D01({ videoItem }) {
  const [isOpen, setIsOpen] = useState(false);
  const [videoId, setVideoId] = useState(null);

  function openVideo(id) {
    setVideoId(id);
    setIsOpen(true);
  }

  return (
    <section>
      <div className="container m-auto pt-[10px] pb-[1rem] px-[1rem] sm:px-[2rem] lg:px-[3rem]">
        <div className="grid grid-rows">
          {videoItem?.advanceData?.data?.length && (
            <div className="grid grid-cols-12 gap-[1rem]">
              {videoItem.advanceData.data.map((item, index) => (
                <div
                  className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4 xl:col-span-4"
                  key={index}
                >
                  {item?.url && (
                    <div className="w-full h-full relative">
                      <WsrvImage
                        src={`https://i.ytimg.com/vi/${item.url}/hq720.jpg`}
                        alt="video thumbnail"
                        width={640}
                        height={360}
                        widths={[320, 480, 640]}
                        sizes="(max-width: 768px) 100vw, 640px"
                        className="w-full h-auto"
                      />
                      <div
                        className="absolute w-[40px] -translate-x-2/4 -translate-y-2/4 left-2/4 top-2/4 cursor-pointer"
                        onClick={() => openVideo(item.url)}
                      >
                        <WsrvImage
                          src="https://i.filecdn.in/831sgoi/youtube-1700310763224.png"
                          alt="youtube play"
                          width={40}
                          height={40}
                          widths={[40, 80]}
                          className="w-full h-auto"
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="relative bg-white w-full max-w-3xl rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsOpen(false)}
              className="absolute -top-3 -right-3 z-10 bg-white w-8 h-8 flex items-center justify-center rounded-full shadow-md hover:bg-gray-200 text-lg font-bold"
            >
              ✕
            </button>
            <div className="w-full">
              <iframe
                width="100%"
                height="315"
                src={`https://www.youtube.com/embed/${videoId}`}
                title="My video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
